module.exports = __webpack_public_path__ + "img/logo.647d6322.png";